import { Group, Button, ActionIcon, Text, Tooltip } from "@mantine/core";
import { IconCalendarEvent, IconChevronLeft, IconChevronRight, IconFilter, IconFilterFilled } from "@tabler/icons-react";
import { type ToolbarProps, type View } from "react-big-calendar";

interface IEncabezadoAgenda extends ToolbarProps {
  manejarHabilitarFiltros: (estado: boolean) => void;
  habilitarFiltros: boolean;
}

const EncabezadoAgendaVista = ({
  label,
  // date,           // toolbar recibe la fecha actual
  onNavigate,
  onView,
  view,
  // views,
  manejarHabilitarFiltros,
  habilitarFiltros,
}: IEncabezadoAgenda) => {

  const viewLabels: Record<View, string> = {
    month: "Mes",
    week: "Semana",
    work_week: "Semana Laboral",
    day: "Día",
    agenda: "Agenda",
  };

  const handleNav = (action: "PREV" | "TODAY" | "NEXT" | "DATE") => {
    if (typeof onNavigate === "function") {
      onNavigate(action as any);
    }
  };

  return (
    <Group justify="space-between" pt="xs" pb="xs" style={{ width: "100%", alignItems: "center" }}>
      <Group justify="space-evenly">
        <ActionIcon radius="lg" variant="light" size="md" onClick={() => handleNav("PREV")}>
          <IconChevronLeft size={16} />
        </ActionIcon>
        <Button radius="lg" variant="light" size="compact-md" onClick={() => handleNav("TODAY")}>
          <Text fw={600} fz="xs">Hoy</Text>
        </Button>

        <ActionIcon radius="lg" variant="light" size="md" onClick={() => handleNav("NEXT")}>
          <IconChevronRight size={16} />
        </ActionIcon>
        <IconCalendarEvent color='var(--mantine-primary-color-filled)' />
        <Text fw={600}>{label}</Text>
      </Group>

      <div style={{ background: '#e5f1fb', borderRadius: '20px', padding: '4px' }} >
        <Group style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Tooltip zIndex={100000} label="Filtros" style={{ fontSize: '10px', padding: '3px 5px' }} withinPortal openDelay={100}>
            <ActionIcon
              variant="subtle"
              color="primary"
              radius="xl"
              onClick={() => manejarHabilitarFiltros(!habilitarFiltros)}
            >
              {habilitarFiltros ? <IconFilterFilled size={16} /> : <IconFilter size={16} />}
            </ActionIcon>
          </Tooltip>
          {(["month", "week", "day", "agenda"] as View[]).map((v) => (
            <Button
              key={v}
              radius={'lg'}
              variant={view === v ? "gosth" : "transparent"}
              size="compact-sm"
              onClick={() => onView(v)}
              style={{
                transition: "all 0.3s ease",
              }}
            >
              <Text fw={600} fz={12}>
                {viewLabels[v]}</Text>
            </Button>
          ))}
        </Group>
      </div>
    </Group>
  );
};

export default EncabezadoAgendaVista;
